import Image from 'next/image';
import Link from 'next/link';
import styles from './ChallengeCard.module.css';

// Define the type for the props expected by the ChallengeCard component
type ChallengeCardProps = {
  projectId: string;
  imageUrl?: string;
  imageAlt: string;
  sdgText: string;
  industriesText?: string;
  title: string;
  description: string;
  location: string;
  savesCount: string;
};

// The ChallengeCard component definition with props
const ChallengeCard: React.FC<ChallengeCardProps> = ({
  projectId,
  imageUrl,
  imageAlt,
  sdgText,
  industriesText,
  title,
  description,
  location,
}) => {
  return (
    <Link className={styles.ChallengeCard} href={`/projects/${projectId}`}>
      <header className={styles.header}>
        <Image
          src={imageUrl || '/assets/img/img-not-available.png'}
          alt={imageAlt}
          width={300}
          height={400}
          className={styles.image}
        />
        <div className={styles.overlayText}>
          {sdgText && <span className={styles.sdg}>{sdgText}</span>}
          {industriesText && <span className={styles.industries}>{industriesText}</span>}
        </div>
      </header>
      <div className={styles.content}>
        <h4 className={styles.title}>{title}</h4>
        <p className={styles.description}>{description}</p>
        <footer className={styles.footer}>
          <div className={styles.location}>
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10 10.4165C11.3808 10.4165 12.5 9.29722 12.5 7.9165C12.5 6.53579 11.3808 5.4165 10 5.4165C8.61933 5.4165 7.50004 6.53579 7.50004 7.9165C7.50004 9.29722 8.61933 10.4165 10 10.4165Z"
                stroke="#98A2B3"
                strokeWidth="1.66667"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M10 18.3332C11.6667 14.9998 16.6667 12.8484 16.6667 8.33317C16.6667 4.65127 13.6819 1.6665 10 1.6665C6.31814 1.6665 3.33337 4.65127 3.33337 8.33317C3.33337 12.8484 8.33337 14.9998 10 18.3332Z"
                stroke="#98A2B3"
                strokeWidth="1.66667"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <p>{location}</p>
          </div>
        </footer>
      </div>
    </Link>
  );
};

export default ChallengeCard;
